import xhrService from '../xhrService';
import {
  ReopenFindingApi,
  SignatureGroupType,
} from '@stormwater-software/lib-certification';
import db from '../../db/db';
import { apiError } from '../apiError';
import { withOfflineWrite } from '../offlineFallback';

export const inspectionFindingReopeningLogApi: ReopenFindingApi = {
  show: (findingId: number) =>
    xhrService
      .get(`/api/findings/${findingId}/open`)
      .then((res) => res.data)
      .catch((err) => {
        throw apiError(err);
      }),
  update: async (findingId: number) => {
    // SW2-2321: was a `navigator.onLine` pre-check. Reopening after an offline
    // reload posted to the network, failed, and never applied the local change —
    // so the item stayed closed and the inspector's reopen was lost.
    return withOfflineWrite<any>(
      () =>
        xhrService
          .post(`/api/findings/${findingId}/open`)
          .then((res) => res.data)
          .catch((err) => {
            throw apiError(err);
          }),
      async () => {
        try {
          const finding = await db.findings.get(findingId);

          finding.date_completed = null;
          finding.sync.payload = finding.sync.payload.filter(
            (item: any) => item.method !== 'update',
          );

          const existingCertification = await db.certifications.get(
            finding.InspectionFindingModel.inspection_id,
          );

          existingCertification.userSignatures[SignatureGroupType.compliance] =
            [];
          existingCertification.sync.payload =
            existingCertification.sync.payload.filter(
              (item: any) => item.group !== 'compliance',
            );

          existingCertification.groupOptions['compliance'].enabled = false;
          if (
            existingCertification.groupOptions['compliance'].errors.indexOf(
              'Findings need to be completed prior to signing',
            ) === -1
          ) {
            existingCertification.groupOptions['compliance'].errors.push(
              'Findings need to be completed prior to signing',
            );
          }

          // Awaited: unawaited, the queue callback could resolve — reporting a
          // successful reopen — while either write was still pending, and a
          // rejection would surface as an unhandled promise rather than failing
          // the reopen. (Raised by Copilot on PR #53.)
          await db.inspections.update(
            finding.InspectionFindingModel.inspection_id,
            { compliance_date: '' },
          );
          await db.certifications.update(
            finding.InspectionFindingModel.inspection_id,
            existingCertification,
          );

          const inspection = await db.inspections.get(
            finding.InspectionFindingModel.inspection_id,
          );

          if (!inspection) {
            throw new Error('Inspection not found');
          }

          await db.inspections.update(Number(inspection.id), {
            findings: [
              ...inspection!.findings.filter((f: any) => f.id !== findingId),
              finding,
            ],
          });

          return db.findings.put(finding).then(() => ({ finding }));
        } catch (error) {
          console.error('Error updating finding in offline mode:', error);
          throw new Error('Failed to update finding in offline mode');
        }
      },
      // SW2-2321: `localOnlyWhenOffline` because nothing replays a reopen — the
      // sync loop handles only create/update payloads, and this path actually
      // *removes* the pending update payload. Resolving on an unreachable server
      // would report the finding reopened while it stays closed on the server,
      // and the next download would overwrite the local state.
      // (Raised by Copilot on PR #53.)
      { localOnlyWhenOffline: true },
    );
  },
};

export default inspectionFindingReopeningLogApi;
